window.locales = window.locales || {};window.locales.am = window.locales.am || {};window.locales.am.diplomaCheckBox = window.locales.am.diplomaCheckBox || {};window.locales.am.diplomaCheckBox = {...window.locales.am.diplomaCheckBox, ...{
    "heading": "ዲፕሎማ ማረጋገጫ",
    "content": "ስምዎ በዲፕሎማዎ ላይ እንደሚታየ ይፈልጋሉ? የመልእክት አድራሻው ትክክል ነው?",
    "buttonUpdateName": "ስም አዘምን",
    "buttonUpdateAddress": "አድራሻ አዘምን",
    "buttonInternationalTracking": "አማራጭ ዓለም አቀፍ ክትትል ያክሉ"
}
};window.locales.ar = window.locales.ar || {};window.locales.ar.diplomaCheckBox = window.locales.ar.diplomaCheckBox || {};window.locales.ar.diplomaCheckBox = {...window.locales.ar.diplomaCheckBox, ...{
    "heading": "فحص الشهادة",
    "content": "هل يظهر اسمك كما تريد أن يظهر في شهادتك؟ هل العنوان البريدي دقيق؟",
    "buttonUpdateName": "تحديث الاسم",
    "buttonUpdateAddress": "تحديث العنوان",
    "buttonInternationalTracking": "إضافة التتبع الدولي الاختياري"
}
};window.locales.en = window.locales.en || {};window.locales.en.diplomaCheckBox = window.locales.en.diplomaCheckBox || {};window.locales.en.diplomaCheckBox = {...window.locales.en.diplomaCheckBox, ...{
    "heading": "Diploma Check",
    "content": "Does your name appear as you'd like it to be shown on your diploma? Is the mailing address accurate?",
    "buttonUpdateName": "Update Name",
    "buttonUpdateAddress": "Update Address",
    "buttonInternationalTracking": "Add Optional International Tracking"
}
};window.locales.es = window.locales.es || {};window.locales.es.diplomaCheckBox = window.locales.es.diplomaCheckBox || {};window.locales.es.diplomaCheckBox = {...window.locales.es.diplomaCheckBox, ...{
    "heading": "Verificación de Diploma",
    "content": "¿Su nombre aparece como le gustaría que se muestre en su diploma? ¿Es exacta la dirección postal?",
    "buttonUpdateName": "Actualizar Nombre",
    "buttonUpdateAddress": "Actualizar Dirección",
    "buttonInternationalTracking": "Agregar Seguimiento Internacional Opcional"
}
};window.locales.it = window.locales.it || {};window.locales.it.diplomaCheckBox = window.locales.it.diplomaCheckBox || {};window.locales.it.diplomaCheckBox = {...window.locales.it.diplomaCheckBox, ...{
    "heading": "Controllo Diploma",
    "content": "Il tuo nome appare come vorresti che fosse mostrato sul tuo diploma? L'indirizzo postale è corretto?",
    "buttonUpdateName": "Aggiorna Nome",
    "buttonUpdateAddress": "Aggiorna Indirizzo",
    "buttonInternationalTracking": "Aggiungi Tracciamento Internazionale Opzionale"
}
};window.locales.zh = window.locales.zh || {};window.locales.zh.diplomaCheckBox = window.locales.zh.diplomaCheckBox || {};window.locales.zh.diplomaCheckBox = {...window.locales.zh.diplomaCheckBox, ...{
    "heading": "文凭检查",
    "content": "您的姓名是否按照您希望在文凭上显示的方式出现？邮寄地址是否准确？",
    "buttonUpdateName": "更新姓名",
    "buttonUpdateAddress": "更新地址",
    "buttonInternationalTracking": "添加可选国际追踪"
}
};